export const FEATURE_FLAGS = {
  // Value is camelCase because OliveBranch middleware transforms snake_case keys in the API response
  SHOPIFY: 'shopify',
  SHOPIFY_ADD_TO_CART: 'shopifyAddToCart',
  INTERCOM: 'intercom',
  // Backend flag name: support_integrations (camelCased here for the response key)
  SUPPORT_INTEGRATIONS: 'supportIntegrations',
  // Backend flag name: klaviyo. Gates the Klaviyo integration card/modal until rollout.
  KLAVIYO: 'klaviyo',
  // Backend flag name: clickpoint. Gates the ClickPoint integration card/modal until rollout.
  CLICKPOINT: 'clickpoint',
  // Backend flag name: page_view_capture. Gates the org capture toggle until rollout.
  PAGE_VIEW_CAPTURE: 'pageViewCapture',
  PDP_QA: 'pdpQa',
  ONSITE_WIDGET: 'onsiteWidget',
  EXPERIENCE_BUILDER_POC: 'experienceBuilderPoc',
  SITE_HEALTH: 'siteHealth',
} as const
